// src/pdf/fonts/raleway.ts
import jsPDF from "jspdf";

// Import raw base64 text (Vite will inline file content)
import RalewayRegularRaw from "../../fonts/Raleway-Regular.base64.txt?raw";
import RalewayBoldRaw from "../../fonts/Raleway-Bold.base64.txt?raw";


function cleanBase64(s: unknown) {
  return String(s || "")
    .replace(/^\uFEFF/, "") // BOM
    .replace(/\s+/g, "") // remove newlines/spaces
    .replace(/^"|"$/g, ""); // accidental wrapping quotes
}

export function ensureRaleway(doc: jsPDF) {
  try {
    const regular = cleanBase64(RalewayRegularRaw);
    const bold = cleanBase64(RalewayBoldRaw);

    (doc as any).addFileToVFS("Raleway-Regular.ttf", regular);
    (doc as any).addFont("Raleway-Regular.ttf", "Raleway", "normal");

    (doc as any).addFileToVFS("Raleway-Bold.ttf", bold);
    (doc as any).addFont("Raleway-Bold.ttf", "Raleway", "bold");

    return true;
  } catch (e) {
    console.warn("[PDF] Raleway registration failed; falling back to Helvetica", e);
    return false;
  }
}
